export const styles = {
  chip: {
    // '&.MuiChip-root': {
    //   pointerEvents: 'none',
    //   maxHeight: '22px',
    //   border: '1px solid',
    //   borderRadius: '4px',
    //   inlineSize: 'fit-content',
    // },
    // '&.MuiChip-label': {
    //   padding: '2px 8px',
    //   marginTop: 'auto',
    // },
    height: '22px',
    borderRadius: '4px',
    inlineSize: 'fit-content',
    '.MuiChip-label': {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    '&.MuiChip-outlinedWarning': {
      color: '#F0901E',
      borderColor: '#F0901E',
      backgroundColor: '#FFF0DD',
    },
    '&.MuiChip-outlinedSuccess': {
      color: '#33C341',
      borderColor: '#33C341',
      backgroundColor: '#EFFFEE',
    },
    '&.MuiChip-outlinedPrimary': {
      color: '#009FDA',
      borderColor: '#009FDA',
      backgroundColor: '#EAF8FF',
    },
    '&.MuiChip-outlinedError': {
      color: '#FF4D4F',
      borderColor: '#FF4D4F',
      backgroundColor: '#FFEAEA',
    },
  },
}
